import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { DayMap, DayTimetable } from "@/components/scheduler/RunPreview";

const dayName = (iso) => (iso ? new Date(iso + "T00:00:00").toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : "");

export default function RunPrint() {
  const { id } = useParams();
  const [run, setRun] = useState(null);
  const printed = useRef(false);
  useEffect(() => { api.get(`/runs/${id}`).then((r) => setRun(r.data)).catch(() => setRun(false)); }, [id]);
  useEffect(() => {
    if (run && run !== false && !printed.current) {
      printed.current = true;
      setTimeout(() => window.print(), 1800); // let maps render
    }
  }, [run]);

  if (!run) return <div className="p-10 text-slate-500">Loading…</div>;
  if (run === false) return <div className="p-10 text-slate-500">Run not found.</div>;

  return (
    <div className="max-w-4xl mx-auto p-8 bg-white" data-testid="run-print">
      <style>{`@media print { .no-print { display:none } @page { margin: 12mm } .day-sheet { page-break-after: always } }`}</style>
      <div className="flex items-center justify-between border-b-2 border-slate-900 pb-3 mb-5">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">{run.name}</h1>
          <p className="text-sm text-slate-500 font-mono">{run.run_id} · {(run.days || []).length}-day run</p>
        </div>
        <button onClick={() => window.print()} className="no-print px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-semibold">Print</button>
      </div>
      {run.preview.days.map((d, i) => (
        <div key={i} className="day-sheet mb-8">
          <div className="bg-slate-900 text-white rounded-t-lg px-4 py-2 flex items-center justify-between">
            <span className="font-bold">Day {i + 1} — {dayName((d.config || {}).date)}</span>
            <span className="text-sm">{(d.config || {}).van_title || "Van"}{(d.config || {}).driver ? ` · ${(d.config || {}).driver}` : ""} · {(d.config || {}).start_time}–{(d.config || {}).end_time}</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 border border-slate-200 rounded-b-lg p-4">
            <DayTimetable day={d} index={i} linkStops={false} />
            <DayMap legs={d.legs} height={340} />
          </div>
        </div>
      ))}
      {run.preview.unassigned.length > 0 && (
        <div className="mt-4 border border-rose-300 rounded-lg p-4">
          <h3 className="font-bold text-rose-700 mb-1">Unscheduled shifts</h3>
          <ul className="text-sm text-rose-700 space-y-0.5">
            {run.preview.unassigned.map((u) => <li key={u.shift_id}>{u.shift_id} — {u.reason}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
